import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as NotificationActions from 'rebook/apps/users/actions/NotificationActions';
import * as BookDetailActions from 'rebook/apps/books/actions/BookDetailActions';
import Rating from 'rebook/apps/base/components/Rating';

import { EmptyStar, FilledStar } from './images/rating';
import notificationMessages from './constants';


class BookPageHeaderUserRating extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      localUserRating: null,
    };
  }

  updateUserRating(newValue = 0) {
    this.setState({
      localUserRating: newValue,
    });
  }

  rateBook(value) {
    const { NotificationActions, BookDetailActions, book, ratingValue } = this.props;
    NotificationActions.pop(notificationMessages.rating);
    // update the ui optimistically
    this.updateUserRating(value);

    const url = `/api/books/${book.id}/rate/`;
    const params = {
      apiVersion: 4,
      method: 'post',
      json: {
        book_rating: value,
      },
    };
    fetchQuery(url, params)
      .then(() => {
        ga('send', 'event', 'Rate');
        BookDetailActions.fetchDetail({ params: { bookSlug: book.slug } });
      })
      // revert to the latest rating value on failure
      .catch(() => this.updateUserRating(ratingValue));
  }

  unrateBook() {
    const { BookDetailActions, book } = this.props;
    // update the ui optimistically
    this.updateUserRating();
    const url = `/api/books/${book.id}/unrate/`;
    const params = {
      method: 'post',
      apiVersion: 4,
    };
    fetchQuery(url, params)
      .then(() => {
        ga('send', 'event', 'Unrate');
        BookDetailActions.fetchDetail({ params: { bookSlug: book.slug } });
      })
      // revert to the latest rating value on failure
      .catch(() => this.updateUserRating(this.props.ratingValue));
  }

  handleRate(rating) {
    if (!this.props.user) {
      this.props.AuthFormActions.showForm();
    }
    else {
      rating ? this.rateBook(rating) : this.unrateBook();
    }
  }

  render() {
    const { user_rating: userRating } = this.props.book;
    const { localUserRating } = this.state;
    // user's book rating as reported by the server
    const serverUserRating = userRating ? userRating.book_rating : null;
    // effective book rating
    // i.e. it was changed or removed client side so we have to ignore the server's value in this case
    const UIUserRating = localUserRating !== null ? localUserRating : serverUserRating;

    return (
      <Rating
        emptySymbol={<EmptyStar />}
        fullSymbol={<FilledStar />}
        initialRating={UIUserRating ? Math.floor(UIUserRating) : 0}
        onRate={(rating) => this.handleRate(rating)} />
    );
  }
}

BookPageHeaderUserRating.propTypes = {
  book: PropTypes.shape({
    id: PropTypes.number.isRequired,
    user_rating: PropTypes.shape({
      book_rating: PropTypes.number.isRequired,
    }),
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    user: state.user,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    NotificationActions: bindActionCreators(NotificationActions, dispatch),
    BookDetailActions: bindActionCreators(BookDetailActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BookPageHeaderUserRating);
